module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw TitlePage-rw exclude-print-rw",
    attrs: {
      "epub:type": "frontmatter titlepage",
      "id": "BookTitlePage1"
    }
  }, [_c('div', {
    staticClass: "BookTitlePage",
    attrs: {
      "id": "page-iii"
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('img', {
    staticStyle: {
      "height": "85%"
    },
    attrs: {
      "alt": "Book Title Page",
      "src": "images/Art_tit.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "city"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("orbitbooks.net")])]), _vm._v(" "), _c('p', {
    staticClass: "city1"
  }, [_c('span', {
    staticClass: "center"
  }, [_vm._v("orbitshortfiction.com")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60e8d0e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/titlepage.vue
// module id = 60
// module chunks = 0